module.exports = __webpack_public_path__ + "static/media/Logo.24b12aea.svg";